
var SvgWriter__prototype = SvgWriter.prototype;